import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Account } from '@df/account/account.interfaces';
import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { Nexus } from '@tomandco/nexus-api-types';
import extend from 'lodash-es/extend';

@Directive()
export abstract class AccountEditComponentDef extends AbstractFormComponent<Account.IEditFormData> implements OnInit, OnDestroy {
    /**
     * Submission endppoint
     */
    protected submitPath = Nexus.Api.Customer.Save.path;

    /**
     * Successfull submission event
     */
    protected override successEvent = Account.CUSTOMER_DATA_UPDATE_EVENT;

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.app.customer.model.obs.data.subscribe(() => this.reset()));
    }

    /**
     * Override reset method to initiate the form with customer data
     */
    override reset() {
        this.data = extend({}, this.app.customer.model.data);
        this.detectChanges();
    }
}
